import React, { useEffect, useState } from "react";
import { logo, logoGray } from "../../../assets/images";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetRenewCheckoutData,
  paymentFailureService,
  paymentSuccessService,
} from "../../../api/Register";
import Footer from "../../../Components/common/Footer";
import { formatToCurrency, loadScript } from "../../../utils/commonFunction";
import { GetPaymentData } from "../../../api/common";
import { RAZORPAY_KEY } from "../../../config/constant";
import { tostE, tostS } from "../../../config/tostConfig";
import Loading from "../../../Components/ui/Loading";
// import moment from "moment";

export default function RenewCheckout() {
  const { user_id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [check, setCheck] = useState(false);
  const [getDataLoading, setGetDataLoading] = useState(false);

  const getData = async () => {
    setGetDataLoading(true);
    try {
      const res = await GetRenewCheckoutData(user_id);
      if (res.status === 200) {
        setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
      navigate("/");
    } finally {
      setGetDataLoading(false);
    }
  };

  useEffect(() => {
    getData();
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  }, []); // eslint-disable-line

  const handleMakePayment = async () => {
    setLoading(true);
    try {
      const res = await GetPaymentData(user_id, data.total, "renew");
      if (res.status === 200 && res.data.success) {
        const respData = res.data.data;

        const options = {
          key: RAZORPAY_KEY, // Replace with your Razorpay key ID
          amount: respData.total_amount * 100, // Amount in the smallest currency unit (e.g., paise for INR)
          currency: "INR",
          name: "EEMA",
          description: "Event & Entertainment Management Association",
          image: logo,
          order_id: respData.unique_order_id, // Replace with your generated order ID
          handler: async function (response) {
            const sendData = {
              ...response,
              history_id: data.plan_history.id,
              history_type: "renew",
            };
            setGetDataLoading(true);
            try {
              const res = await paymentSuccessService(sendData);
              if (res.status === 200 && res.data.success) {
                tostS(`Payment successful!`);
                navigate(`/app/thank-you/${respData.unique_order_id}`, {
                  replace: true,
                });
              } else {
                tostE(res.message);
              }
            } catch (error) {
              tostE(error.message);
            } finally {
              setGetDataLoading(false);
            }
          },
          prefill: {
            name: respData.name,
            email: respData.email,
            contact: respData.mobile_number,
          },
          notes: {
            regarding: "Renew Fee",
          },
          theme: {
            color: "#D37C51",
          },
        };
        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", async function (response) {
          setGetDataLoading(true);
          try {
            const res = await paymentFailureService({
              ...response.error,
              history_id: data.plan_history.id,
            });
            if (res.status === 200 && res.success) {
              tostE("Payment failed. Please try again.");
            }
          } catch (error) {
            console.log(error);
          } finally {
            setGetDataLoading(false);
          }
        });

        rzp.open();
      }
      // If payment link expired
      if(res.status === 200 && !res.data.success && res.data?.payment_link_expired){
        navigate(`/payment-expired`, { replace: true });
      }
    } catch (error) {
      tostE("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {getDataLoading && <Loading />}
      <div className="customContainer">
        <div className="headingTexts ">
          <h2>Checkout</h2>
        </div>

        <div className="row">
          <div className="col-md-7 col-lg-7 col-xl-7 col-xxl-7">
            <div className="orderDetails">
              <div className="userdetailsCard">
                {data.plan_history && (
                  <div className="dataRow">
                    <div>Member Name </div>
                    <div>{data.plan_history.company_name}</div>
                  </div>
                )}
                <div className="dataRow">
                  <div>Authorized Person </div>
                  <div>{data.Name}</div>
                </div>
                <div className="dataRow">
                  <div>Email</div>
                  <div>{data.Email}</div>
                </div>
                <div className="dataRow">
                  <div>Category </div>
                  <div>{data.Plan_Name}</div>
                </div>
                {data.plan_history && (
                  <div className="dataRow">
                    <div>Period</div>
                    {/* <div>{moment(data.plan_history.membership_expiry).add(1, "minute").format("DD-MMM-YYYY")} to {moment(data.plan_history.membership_expiry).add(1, "year").format("DD-MMM-YYYY")}</div> */}
                    <div>01 April 2026 to 31 March 2027</div>
                  </div>
                )}
                <div className="dataRow">
                  <div>Annual Fee </div>
                  <div>
                    <span style={{ fontFamily: "arial" }}>₹ </span>
                    {formatToCurrency(data.Annual_Fees)}
                  </div>
                </div>
                <div className="dataRow">
                  <div>GST (18%)</div>
                  <div>
                    <span style={{ fontFamily: "arial" }}>₹ </span>
                    {formatToCurrency(data.gst)}
                  </div>
                </div>
                {data?.Plan_Name?.toLowerCase() === "platinum" && <div className="dataRow">
                  <div>TDS (2%)</div>
                  <div>
                    <span style={{ fontFamily: "arial" }}>₹ </span>
                    {formatToCurrency(data.tds)}
                  </div>
                </div>}
              </div>
              <div className="confirmDetails">
                <div className="form-check form-check-inline eligibleText">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox1"
                    checked={check}
                    onChange={(e) => setCheck(e.target.checked)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="inlineCheckbox1"
                    style={{ fontSize: "16px", fontWeight: "300" }}
                  >
                    I hereby confirm the accuracy of details given above.
                  </label>
                </div>
                <p className="m-0" style={{ color: "#343434" }}>
                  **For any escalations, please contact{" "}
                  <a
                    href="mailto:accounts@eemaindia.com"
                    style={{ color: "#D37C51" }}
                  >
                    accounts@eemaindia.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-4 offset-xl-1 col-xxl-4 offset-xxl-1">
            <div className="text-end">
              {" "}
              <img src={logoGray} alt="" />{" "}
            </div>

            <div className="totalAmount">
              <div>
                {" "}
                <strong>
                  <span style={{ fontFamily: "arial" }}>₹ </span>
                  {formatToCurrency(data.total)}
                </strong>
              </div>
              <p>Amount Payable</p>
            </div>
          </div>
        </div>
      </div>
      <Footer
        isNextAllowed={!loading && check}
        isBackAllowed
        nextButtonAction={() => {
          handleMakePayment();
        }}
        backButtonAction={() => {
          navigate("/app/plan-status", { replace: true });
        }}
      />
    </>
  );
}
